import React, { useState, useEffect, useContext } from 'react';
import { CdnImage, CdnPath } from '../../shared/cdn-image';
import Loader from '../../shared/loader';
import QuoteContext from "../quote-context";
import axios from 'axios';

const Packages = ({ locationId, processForm, packages }) => {

    const {navigation, navigationDispatcher, formData, formDispatcher} = useContext(QuoteContext);
    //const [ packages, setPackages ] = useState( [] )
    const [ loading, setLoading ] = useState( false )
    const [ filters, setFilters ] = useState( [] )
    const [ selectedFilter, setSelectedFilter ] = useState( 'any' )

    /*
    useEffect(() => {
    		
    	let isMounted = true;
    	
        axios.get( '/quote/v2/packages/' + navigation.destination.id ).then(response => {
            
            if( isMounted ) {
				setLoading(false);
				setPackages( response.data.packages );
				setFilters( response.data.filters );
            }
        }).catch(err => {
            setLoading(false);
            const message = ( err.response != null && err.response.data != null && err.response.data.message != null ) ? err.response.data.message : err.message;
            navigationDispatcher({type: "RAISE_ERROR", message: message, code: null });
            navigationDispatcher({
                type: 'TRACK_EVENT',
                action: 'error',
                category: 'load-errors',
                name: 'load-packages',
                trigger: 'web-js',
                data:  {
                    message: message,
                    code: null
                }
            });
        });

        // Clean-up:    
        return () => {
        	isMounted = false;
        }
	}, [none]])
	*/

    return (
      <>
        { loading ? (
			<Loader />
        ) : (
		<>
		<div className="full-width-block white">
			<div className="row no-padding">
				<div className="column">
					<Filters 
						filters={filters} 
						selectedFilter={selectedFilter}
						setSelectedFilter={setSelectedFilter}
					/>
				</div>
			</div>
		</div>
					
		<div className="full-width-block white mg-t-sm">
			<div className="row no-padding">
				<div className="align-content grid wrap">	
				{ packages.length > 0 ?
					<>
						{packages.map( thisPackage => {

							const fullPrice = Number(thisPackage.price) + (Number(thisPackage.price) * 0.05);

							if( selectedFilter == 'any' || selectedFilter == thisPackage.nights ) {
								
								return (
									<div key={`sp-` + thisPackage.id} className="grid-item one-third half-tab mg-b-lrg">
								
										<a className="link plain dir-col relative full-height pointer" onClick={(event) => {
											navigationDispatcher({
												type: 'OPEN_MODAL',
												modal: './quote/modal/package',
												title: thisPackage.name,
												payload: {
													siteId: navigation.siteId,
													locationId: navigation.destination.id,
													id: thisPackage.id,
													hasButton: true,
													image: `${CdnPath( navigation.siteId, `${thisPackage.image.path}/${thisPackage.image.name}`)}`,
													addPackage: ( selectedPackage, nights ) => {
														
														if( selectedPackage.hotelAllowed && selectedPackage.hotel ) {
															formDispatcher({type: "RESET_ACTIVITIES_AND_HOTEL" });
														} else {
															formDispatcher({type: "RESET_ACTIVITIES" });
														}
														
														/*
														if( navigation.loggedIn ) {
															processForm( selectedPackage );
														}  else {
															formDispatcher({type:"ADD_PACKAGE", package: selectedPackage});
															navigationDispatcher({ type: "GOTO_STEP", step: "submit", params: : { isPackage: false }});
														}
														*/
														
														selectedPackage.events.map((event) => {
															formDispatcher({type: "ADD_ACTIVITY", event:{
																id: event.id,
																day: 1,
																name: event.name,
																period: event.day ? 0 : 1,
																preferredTimeSlot: event.day ? 0 : 2,
																image:  event.image
															}})	
														})
																												
														if( selectedPackage.hotelAllowed && selectedPackage.hotel ) {
															formDispatcher({type: "ADD_HOTEL", hotel:{
																id: selectedPackage.hotel.id,
																type: "named",
																name: selectedPackage.hotel.name,
																day: 1,
																nights: nights,
																image: selectedPackage.hotel.image
															}})
														}
															
														navigationDispatcher({
															type: 'TRACK_EVENT',
															action: 'event',
															category: 'click',
															name: 'add-package',
															trigger: 'web-js',
															data: {
																id: selectedPackage.id,
																name: selectedPackage.name
															}
														});
														
														if( selectedPackage.hotelAllowed && !selectedPackage.hotel ) {
															navigationDispatcher({ type: "GOTO_STEP", step: navigation.hasHotels ? "accommodation" : "itinerary", params: { isPackage: true } })
														} else {
															if( navigation.loggedIn ) {
																//TODO: PROCESS QUOTE
																navigationDispatcher({ type: "GOTO_STEP", step: "itinerary", params: null});
															} else {
																navigationDispatcher({ type: "GOTO_STEP", step: "submit", params: null});
															}
														}
													}
												}
											})

											navigationDispatcher({
												type: 'TRACK_EVENT',
												action: 'event',
												category: 'click',
												name: 'view-superpackage',
												trigger: 'web-js',
												data: {
													id: thisPackage.id,
													name: thisPackage.name
												}
											});

										}}>

											<div className="relative">
												<img src={CdnPath( navigation.siteId, `${thisPackage.image.path}/${thisPackage.image.name}` )} className={navigation.siteId == 1 ? "relative height-150 image full-width radius-t" : "relative height-150 image full-width radius-t-lrg" }/>
												<div className="absolute top left mg-l mg-t banner pill yellow"><div className="align-content vertical center"><span className="icon icon-hot black"></span><p className="spirit">Trending</p></div></div>
											</div>
											
											<div className={navigation.siteId != 1 ? "dir-col bg-light-grey pd full-height radius-b-lrg" : "dir-col bg-light-grey pd full-height radius-b"}>
												<div>
													<p className="text-medium bold mg-b-sm">{thisPackage.name}</p>

													{navigation.siteId != 1 ?
														<span className="banner pill white mg-b-sm"><div className="align-content vertical center"><p className="strike mg-r-sm">&pound;{fullPrice.toFixed(2)}</p><p className="quat-secondary bold">From &pound;{thisPackage.price}pp</p></div></span>
													: null
													}
													{thisPackage.events.map((event, index) =>
														<div key={`package-event-${thisPackage.id}-${event.id}`} className="align-content vertical center black mg-b-sm"><div className="icon-holder round xsmall white mg-r-sm"><span className="icon icon-starfull xsmall"></span></div><p>{event.name}</p></div>
													)}
													{thisPackage.accommodation.named != false ?
														<div className="align-content vertical center mg-b-sm"><div className="icon-holder round xsmall white mg-r-sm"><span className="icon icon-singlebed xsmall"></span></div><p>{thisPackage.nights} nights in {thisPackage.accommodation.named.hotel.name}</p></div>
													: null
													}
													<div className="align-content vertical center mg-b-sm">
														<div className="icon-holder round xsmall white mg-r-sm">
															<span className="icon icon-tick quat-secondary xsmall"></span>
														</div>
														<p className="quat-secondary">Just &pound;1 deposit &amp; instalment options</p>
													</div>
												</div>
												<button className="button primary fill-mob split-mob radius mg-t">Find out more <span className="icon icon-arrow-right white right small"></span></button>
											</div>
											
										</a>
										
									</div>
								)
							}
						})}
					</>
				: null }
				</div>
			</div>
        </div>
		</>
       	)}
    </>
	)
}

const Filters = ({ filters, selectedFilter, setSelectedFilter }) => {
	
	const filterName = ( filter ) => {
		
		let name = filter
		
		if( filter >= 3 ) {
			name = '3+'
		}
		
		return name
	}
	
	return (
		<div className="align-content vertical center mg-v radio-tabs">
			<>
			<p className="mg-r-sm">Nights:</p> 
			<span className="align-content vertical center fit-content mg-r-tch-sm mg-r-dsk">
				<input 
					type="radio"
					name="radiotabs"
					value={false} 
					checked={selectedFilter == 'any'}
					onChange={() => {
						setSelectedFilter( 'any' );
					}}
				/><span className="radio-text">Any</span>
			</span>
			</>
			
			{filters.map( filter => {
				
					return (
						
						<span className="align-content vertical center fit-content mg-r-tch-sm mg-r-dsk" key={`filter-${filter}`}>
						<input 
							type="radio"
							name="radiotabs"
							value={filter}
							checked={filter == selectedFilter}
							onChange={() => {
								setSelectedFilter( filter );
							}}
						/>
						<span className="radio-text">{filterName(filter)}</span>
						</span>
					)
			})}
        </div>
     )
}

export default Packages;
